import { IncomingPostbackLogTable } from "components/Tables/IncomingPostbackLogTable/IncomingPostbackLogTable";
import { TenantPage } from "components/UI/TenantPage/TenantPage";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getLogHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/s2s-postback/"
)({
    component: IncomingPostbackLogPage,
    staticData: {
        permissions: [PermissionEnum.IncomingPostbackLogView],
        showInSideMenu: false,
        label: "pages.log.tracking.from.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.log.tracking.from.title"),
        };
    },
});

function IncomingPostbackLogPage() {
    return (
        <TenantPage headerNavigationItems={getLogHeaderItems}>
            <IncomingPostbackLogTable />
        </TenantPage>
    );
}
